/********************************************************************************************************************
 * @file Actions for the board store
 * @author Thomas Gantt <tg14@licorice.io>
 * @since 2.6.0
 * @date 7-Apr-2025
 *********************************************************************************************************************/

import { createAction } from 'redux-actions';

export const setBoards = createAction( 'BOARD.BOARDS/SET' );